import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TreatmentProvider, TreatmentType } from "../../models/TreatmentProviders.models";

@Component({
  selector: 'app-treatment-provider-list-item',
  templateUrl: './treatment-provider-list-item.component.html',
  styleUrls: ['./treatment-provider-list-item.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class TreatmentProviderListItemComponent implements OnInit {
  @Input() treatmentProvider: TreatmentProvider;
  @Output() showProviderEvent: EventEmitter<TreatmentProvider> = new EventEmitter();

  readonly TreatmentType = TreatmentType;
  CityState = "";
  ngOnInit(): void {
    if (this.treatmentProvider.city) {
      this.CityState += this.treatmentProvider.city;
      if (this.treatmentProvider.state) {
        this.CityState += ", ";
        this.CityState += this.treatmentProvider.state;
      }
    } else {
      if (this.treatmentProvider.state) {
        this.CityState += this.treatmentProvider.state;
      }
    }
  }
}
